import React from 'react';
import { Button } from '@/components/common/Button';
import { Icon } from '@/components/common/Icon';
import { Colors } from '@/styles/colors';
import { DEMO_DOC_LINKS } from './NewLinesDocsButtons.const';

export const NewLinesDocsButtons = () =>
  DEMO_DOC_LINKS.map(({ title, url }) => {
    return (
      <Button
        sx={{
          bg: Colors.Blackcurrant_50,
          border: `1px solid ${Colors.Neutral_50}`,
        }}
        size="md"
        icon={<Icon name="DocumentMapIcon" />}
        title={title}
        key={title}
        isActive={false}
        onClick={() => window.open(url, '_blank')}
      />
    );
  });
export default NewLinesDocsButtons;
